module.exports = __webpack_public_path__ + "img/a11y-mobile.4d42356.jpg";